import { mapGetters } from 'vuex'
import SmartPointWidget from './Widgets/SmartPointWidget'

export default {
  computed: {
    ...mapGetters([
      'getSelectedTransporterSmartPointEnable',
      'getSelectedTransporterSmartPoints',
      'getSelectedSmartPoint',
      'getSmartPointIsSelected',
      'getSelectedTransporterSmartPointsApiError',
      'getSelectedTransporterSmartPointsApiErrorMessage',
      'getIsSmartPointOnlyTransporter',
      'getInitializedWidgetsForSmartPoints',
      'getSelectedTransporterObject',
      'getSelectedTransporterClassName',
      'getIsSmartPointAllOptionsTransporter'
    ]),
    shouldDisplaySmartPointSelectionError () {
      return (
        this.getSelectedSmartPoint.id === 0 &&
        this.getSelectedTransporterSmartPointEnable &&
        this.getIsSmartPointOnlyTransporter
      ) || (
        this.getSelectedSmartPoint.id === 0 &&
        this.getSelectedTransporterSmartPointEnable &&
        !this.getIsSmartPointOnlyTransporter &&
        this.getSmartPointIsSelected
      )
    }
  },
  methods: {
    shouldEnableSmartPointSelection (transporterClassName) {
      const selectedTransporter = this.getSelectedTransporterObject
      if (selectedTransporter.useTransporterWidget) {
        return false
      }
      return this.getSelectedTransporterSmartPointEnable && this.getSelectedTransporterSmartPoints.length > 0 && transporterClassName === this.getSelectedTransporterClassName
    },
    shouldEnableSmartPointSelectionWidget (transporterClassName) {
      const selectedTransporter = this.getSelectedTransporterObject
      return this.getSelectedTransporterSmartPointEnable && selectedTransporter.useTransporterWidget && transporterClassName === this.getSelectedTransporterClassName
    },
    smartPointUncheck () {
      this.$store.dispatch('smartPointUncheck')
    },
    async resolveMapInitializationForTransporter () {
      const selectedTransporter = this.getSelectedTransporterObject
      if (selectedTransporter.useTransporterWidget) {
        await this.initializeWidgetForTransporter(selectedTransporter)
        return
      }
      this.$store.dispatch('smartPointClickEvent').then(
        () => this.$refs[`smartPointModal${this.getSelectedTransporterClassName}`].openModal()
      )
    },
    async smartPointClickEvent () {
      const selectedTransporter = this.getSelectedTransporterObject
      if (selectedTransporter.useTransporterWidget) {
        const widget = new SmartPointWidget(selectedTransporter)
        switch (selectedTransporter.class_name) {
          case 'BOXNOW':
            if (!('BOXNOW' in this.getInitializedWidgetsForSmartPoints)) {
              await widget.initializeWidget().finally(() => {
                this.$store.dispatch('setInitializedWidgetsForSmartPoints', { BOXNOW: true })
              })
            }
            this.$store.commit('setSmartPointIsSelected', true)
            this.$root.$emit('BOXNOW_WidgetOpen')
            return
          default:
            return
        }
      }
      await this.$store.dispatch('smartPointClickEvent').then(
        () => this.$refs[`smartPointModal${this.getSelectedTransporterClassName}`].openModal()
      )
    },
    async initializeWidgetForTransporter (selectedTransporter) {
      const widget = new SmartPointWidget(selectedTransporter)
      switch (selectedTransporter.class_name) {
        case 'BOXNOW':
          if ('BOXNOW' in this.getInitializedWidgetsForSmartPoints) {
            this.$root.$emit('BOXNOW_WidgetOpen')
            return
          }
          widget.initializeWidget().finally(() => {
            this.$root.$emit('BOXNOW_WidgetOpen')
            this.$store.dispatch('setInitializedWidgetsForSmartPoints', { BOXNOW: true })
          })
          break
        default:
          break
      }
    }
  }
}
